const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductSearchServiceQuery: any = {
    getStockDetail: Backofficebff + '/v1/productstocks/stockdetail',
    getProductDetail: Backofficebff + '/v1/productstocks/productdetail',
    getProductDetailWithMultipleOption: Backofficebff + '/v1/productstocks/getoptionmultipleids',
    getProductDetailAll: Backofficebff + '/v1/productstocks/productdetailAll',
    getProductDetailWithProductId: Backofficebff + '/v1/productstocks/productdetailwithproductid',
    getOptionIds: Backofficebff + '/v1/productstocks/getoptionids',
    getCommentData: Backofficebff + '/v1/product-comments/list',
    getProductSizeMeasurements: Backofficebff + '/v1/productstocks/productsizemeasurements',
};
